// Avoid `console` errors in browsers that lack a console.
(function () {
  var method;
  var noop = function () {};
  var methods = [
    'assert',
    'clear',
    'count',
    'debug',
    'dir',
    'dirxml',
    'error',
    'exception',
    'group',
    'groupCollapsed',
    'groupEnd',
    'info',
    'log',
    'markTimeline',
    'profile',
    'profileEnd',
    'table',
    'time',
    'timeEnd',
    'timeline',
    'timelineEnd',
    'timeStamp',
    'trace',
    'warn',
  ];
  var length = methods.length;
  var console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
})();

(function ($) {
  // Fire on document ready.
  $(document).ready(function () {

    const slider = new Swiper('.js-slider', {
      // Optional parameters
      direction: "horizontal",
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">0' + (index + 1) + '</span>';
        },
      },
    });

    // -------------------------------------
    // Scrolling (fixed header)
    // -------------------------------------

    /*
    if ($(".js-header").length) {
      var previousScroll = 0,
        headerOrgOffset = $('#header').offset().top;

      $('#header-wrapper').height($('#header').height());

      $(window).scroll(function () {
        var currentScroll = $(this).scrollTop();
        if (currentScroll > headerOrgOffset) {
          if (currentScroll > previousScroll) {
            $('#header').fadeOut();
          } else {
            $('#header').fadeIn();
            $('#header').addClass('fixed');
          }
        } else {
          $('#header').removeClass('fixed');
        }
        previousScroll = currentScroll;
      });
    }
    */

    function scrolling(thisHref, thisSpeed, thisOffset) {
      $.scrollTo(thisHref, thisSpeed, {
        offset: thisOffset,
        axis: 'y',
      });
    }

    // -------------------------------------
    // ScrollTo (click on link)
    // -------------------------------------
    $('.js-scrollto').click(function () {
      var thisHref = $(this).attr('href');
      var thisSpeed = $(this).data('speed');
      var thisOffset = $(this).data('offset');

      scrolling(thisHref, thisSpeed, thisOffset);

      $('.menu-item__link').removeClass('active');
      $(this).addClass('active');

      return false;
    });

    // -------------------------------------
    // Hover on services
    // -------------------------------------

    $('.js-hover').hover(
      function () {
        $(this).addClass('is-hover');
      },
      function () {
        $('.js-hover').removeClass('is-hover');
      }
    );

    $('.js-whole').click(function () {
      var thisLinkHref = $(this).find('.js-link').attr('href');
      location.href = thisLinkHref;
      return false;
    });

    $('.js-hamburger').click(function () {
      $('.js-mobile-menu').toggleClass('is-open');
      $('html').toggleClass('disable-scroll');
    });

    $('.js-popup').magnificPopup({
      type: 'inline',
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $('.js-popup-video').magnificPopup({
      type: 'iframe',
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $('.js-popup-close').click(function () {
      var magnificPopup = $.magnificPopup.instance;
      magnificPopup.close(); // Close popup that is currently opened
    });

    if (!!('ontouchstart' in window)) {
      $('.menu-item-has-children').click(function () {
        var $this = $(this);
        var $thisMenu = $this.find('.sub-menu');
        $thisMenu.toggle();
        return false;
      });

      $('.menu-item-has-children .sub-menu li').click(function (e) {
        e.stopPropagation(); // stop events from bubbling from sub menu clicks
      });
    } else {
      $('.menu-item-has-children').hover(
        function () {
          var $this = $(this);
          var $thisMenu = $this.find('.sub-menu');
          $thisMenu.show();
        },
        function () {
          $('.sub-menu').hide();
        }
      );
    }

    // -------------------------------------
    // Counter
    // -------------------------------------

    $('.js-counter span').counterUp({ time: 1000 });
  });
})(jQuery);
